import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/lib/i18'
const _import = require('./_import_' + process.env.NODE_ENV)
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading
const BASE_URL = '/user'
Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

export const constantRouterMap = [
  { path: '/login', component: _import('login'), hidden: true }
]

export const asyncRouterMap = [
  { path: '/404', component: _import('404'), hidden: true },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/index',
    name: 'Dashboard',
    meta: { title: i18n.t('sidebar.Dashboard') },
    hidden: true
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { title: i18n.t('sidebar.Dashboard') },
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'dashboard',
        meta: { title: i18n.t('sidebar.Dashboard') },
        component: _import('dashboard'),
        hidden: true
      }
    ]
  },
  {
    path: '/menuManage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'menuManage',
        redirect: 'index',
        component: _import('menuManage/index'),
        meta: { title: i18n.t('sidebar.menuManage'), icon: 'menu' },
        children: [
          {
            path: 'index',
            name: 'menuIndex',
            component: _import('menuManage/common/index'),
            hidden: true,
            meta: {
              active: '/menuManage/index',
              title: i18n.t('sidebar.menuList'),
              icon: 'menu'
            }
          },
          {
            path: 'detail/:id',
            name: 'menuDetail',
            component: _import('menuManage/common/detail'),
            hidden: true,
            meta: {
              active: '/menuManage/index',
              title: i18n.t('sidebar.detailMenu'),
              icon: 'menu'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/postManagement',
    component: Layout,
    children: [{
      path: '',
      name: 'postManagement',
      redirect: 'index',
      component: _import('postManagement/index'),
      meta: {
        title: i18n.t('sidebar.postManage'),
        icon: 'menu'
      },
      children: [{
        path: 'index',
        name: 'postIndex',
        component: _import('postManagement/common/index'),
        hidden: true,
        meta: {
          active: '/postManagement/index',
          title: i18n.t('sidebar.postList'),
          icon: 'menu'
        }
      }]
    }]
  },
  {
    path: '/privilegeManage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'privilegeManage',
        redirect: 'index',
        component: _import('privilegeManage/index'),
        meta: { title: i18n.t('sidebar.privilegeManage'), icon: 'privilege' },
        children: [
          {
            path: 'index',
            name: 'privilegeIndex',
            component: _import('privilegeManage/common/index'),
            hidden: true,
            meta: {
              active: '/privilegeManage/index',
              title: i18n.t('sidebar.privilegeList'),
              icon: 'privilege'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/districtManage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'districtManage',
        redirect: 'index',
        component: _import('districtManage/index'),
        meta: { title: i18n.t('sidebar.districtManage'), icon: 'district' },
        children: [
          {
            path: 'index',
            name: 'districtIndex',
            component: _import('districtManage/common/index'),
            hidden: true,
            meta: {
              active: '/districtManage/index',
              title: i18n.t('sidebar.districtList'),
              icon: 'district'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/saleManage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'saleManage',
        redirect: 'index',
        component: _import('saleManage/index'),
        meta: { title: i18n.t('sidebar.saleManage'), icon: 'sale' },
        children: [
          {
            path: 'index',
            name: 'saleIndex',
            component: _import('saleManage/common/index'),
            hidden: true,
            meta: {
              active: '/saleManage/index',
              title: i18n.t('sidebar.saleList'),
              icon: 'sale'
            }
          },
          {
            path: 'edit/:id',
            name: 'saleEdit',
            component: _import('saleManage/common/edit'),
            hidden: true,
            meta: {
              active: '/saleManage/index',
              title: i18n.t('sidebar.editSale'),
              icon: 'sale'
            }
          }
        ]
      }
    ]
  },
  // {
  //   path: '/thirdPartManage',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       redirect: 'index',
  //       name: 'thirdPartManage',
  //       component: _import('common/Layout'),
  //       meta: { title: i18n.t('sidebar.thirdPartManage'), icon: 'thirdAccess' },
  //       children: [
  //         {
  //           path: 'index',
  //           name: 'thirdPartList',
  //           component: _import('thirdAccess/index'),
  //           meta: {
  //             active: '/thirdPartManage/index',
  //             title: i18n.t('sidebar.thirdPartList'),
  //             icon: 'thirdAccess'
  //           },
  //           hidden: true
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    path: '/organizationManage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'organizationManage',
        redirect: 'index',
        component: _import('organizationManage/index'),
        meta: { title: i18n.t('sidebar.orgManage'), icon: 'org' },
        children: [
          {
            path: 'index',
            name: 'organizationIndex',
            component: _import('organizationManage/common/index'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.orgList'),
              icon: 'org'
            }
          },
          {
            path: 'add/:category',
            name: 'organizationAdd',
            component: _import('organizationManage/common/orgAdd'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.addOrg'),
              icon: 'org'
            }
          },
          {
            path: 'edit/:id/:category',
            name: 'organizationEdit',
            component: _import('organizationManage/common/orgEdit'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.editOrg'),
              icon: 'org'
            }
          },
          {
            path: 'editDepartment/:id',
            name: 'editDepartment',
            component: _import('organizationManage/common/departEdit'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.editDepartment'),
              icon: 'org'
            }
          },
          // {
          //   path: 'editPosition/:id',
          //   name: 'editPosition',
          //   component: _import('organizationManage/common/positionEdit'),
          //   hidden: true,
          //   meta: { title: i18n.t('sidebar.editPosition'), icon: 'org' }
          // },
          {
            path: 'addDepartment/:id',
            name: 'addDepartment',
            component: _import('organizationManage/common/departAdd'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.addDepartment'),
              icon: 'org'
            }
          },
          {
            path: 'detail/:id/:category',
            name: 'organizationDetail',
            component: _import('organizationManage/common/orgDetail'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.detailOrg'),
              icon: 'org'
            }
          },
          {
            path: 'detailDepartment/:id',
            name: 'detailDepartment',
            component: _import('organizationManage/common/departDetail'),
            hidden: true,
            meta: {
              active: '/organizationManage/index',
              title: i18n.t('sidebar.detailDepartment'),
              icon: 'org'
            }
          }
          // {
          //   path: 'detailPosition/:id',
          //   name: 'detailPosition',
          //   component: _import('organizationManage/common/positionDetail'),
          //   hidden: true,
          //   meta: { title: i18n.t('sidebar.detailPosition'), icon: 'org' }
          // }
        ]
      }
    ]
  },

  {
    path: '/userMng',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'list',
        name: 'UserMng',
        component: _import('userMng/Layout'),
        meta: { title: i18n.t('sidebar.UserMng'), icon: 'user' },
        children: [
          {
            path: 'list',
            name: 'UserList',
            component: _import('userMng/index'),
            meta: {
              active: '/userMng/list',
              title: i18n.t('sidebar.UserList'),
              icon: 'user'
            },
            hidden: true
          }
        ]
      }
    ]
  },

  // {
  //   path: '/userMng2C',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       redirect: 'list',
  //       name: 'UserMng2C',
  //       component: _import('userMng2C/Layout'),
  //       meta: { title: i18n.t('sidebar.UserMng2C'), icon: 'user' },
  //       children: [
  //         {
  //           path: 'list',
  //           name: 'UserList2C',
  //           component: _import('userMng2C/index'),
  //           meta: {
  //             active: '/userMng2C/list',
  //             title: i18n.t('sidebar.UserList'),
  //             icon: 'user'
  //           },
  //           hidden: true
  //         }
  //       ]
  //     }
  //   ]
  // },

  {
    path: '/roleMng',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'list',
        name: 'RoleMng',
        component: _import('roleMng/Layout'),
        meta: { title: i18n.t('sidebar.RoleMng'), icon: 'role' },
        children: [
          {
            path: 'list',
            name: 'RoleMngList',
            component: _import('roleMng/index'),
            meta: {
              active: '/roleMng/list',
              title: i18n.t('sidebar.RoleList'),
              icon: 'role'
            },
            hidden: true
          },
          {
            path: 'details/:id',
            name: 'RoleDetails',
            component: _import('roleMng/details/index'),
            meta: {
              active: '/roleMng/list',
              title: i18n.t('sidebar.RoleDetails'),
              icon: 'role'
            },
            hidden: true
          },
          {
            path: 'add',
            name: 'RoleAdd',
            component: _import('roleMng/add/index'),
            meta: {
              active: '/roleMng/list',
              title: i18n.t('sidebar.RoleAdd'),
              icon: 'role'
            },
            hidden: true
          },
          {
            path: 'edit/:id',
            name: 'RoleEdit',
            component: _import('roleMng/edit/index'),
            meta: {
              active: '/roleMng/list',
              title: i18n.t('sidebar.RoleEdit'),
              icon: 'role'
            },
            hidden: true
          }
        ]
      }
    ]
  },

  // {
  //   path: '/postMng',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       redirect: 'list',
  //       name: 'PostMng',
  //       component: _import('common/Layout'),
  //       meta: { title: i18n.t('sidebar.PostMng'), icon: 'post' },
  //       children: [
  //         {
  //           path: 'list',
  //           name: 'PostList',
  //           component: _import('postMng/index'),
  //           meta: {
  //             active: '/postMng/list',
  //             title: i18n.t('sidebar.PostList'),
  //             icon: 'post'
  //           },
  //           hidden: true
  //         }
  //       ]
  //     }
  //   ]
  // },

  {
    path: '/appMng',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'list',
        name: 'AppMng',
        component: _import('appMng/Layout'),
        meta: { title: i18n.t('sidebar.AppMng'), icon: 'app' },
        children: [
          {
            path: 'list',
            name: 'AppMngList',
            component: _import('appMng/index'),
            meta: {
              active: '/appMng/list',
              title: i18n.t('sidebar.AppList'),
              icon: 'app'
            },
            hidden: true
          },
          {
            path: 'add',
            name: 'AppAdd',
            component: _import('appMng/add/index'),
            meta: {
              active: '/appMng/list',
              title: i18n.t('sidebar.AppAdd'),
              icon: 'app'
            },
            hidden: true
          },
          {
            path: 'edit/:appId',
            name: 'AppEdit',
            component: _import('appMng/edit/index'),
            meta: {
              active: '/appMng/list',
              title: i18n.t('sidebar.AppEdit'),
              icon: 'app'
            },
            hidden: true
          },
          {
            path: 'shortMsgConf/:appId',
            name: 'shortMsgConf',
            component: _import('appMng/shortMsgConf/index'),
            meta: {
              active: '/appMng/list',
              title: i18n.t('sidebar.shortMsgConf'),
              icon: 'app'
            },
            hidden: true
          }
        ]
      }
    ]
  },

  {
    path: '/reportingLine',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        redirect: 'list',
        component: _import('userMng/Layout'),
        hidden: true,
        children: [
          {
            path: '',
            component: _import('reportLine/index'),
            name: 'ReportLine',
            meta: { active: '/userMng/list' },
            hidden: true
          }
        ]
      }
    ]
  },

  {
    path: '/log',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'list',
        name: 'Log',
        component: _import('common/Layout'),
        meta: { title: i18n.t('sidebar.Log'), icon: 'log' },
        children: [
          {
            path: 'list',
            name: 'LogList',
            component: _import('log/index'),
            meta: {
              active: '/log/list',
              title: i18n.t('sidebar.LogList'),
              icon: 'log'
            },
            hidden: true
          }
        ]
      }
    ]
  },

  // {
  //   path: '/creditDevice',
  //   name: 'CreditDevice',
  //   component: Layout,
  //   meta: { title: i18n.t('sidebar.creditDevice'), icon: 'app' },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'CreditDeviceList',
  //       component: _import('creditDevice/list'),
  //       meta: {
  //         active: '/creditDevice/list',
  //         title: i18n.t('sidebar.creditDeviceList'),
  //         icon: 'app'
  //       }
  //     },
  //     {
  //       path: 'audit',
  //       name: 'CreditDeviceAudit',
  //       component: _import('creditDevice/audit'),
  //       meta: {
  //         active: '/creditDevice/audit',
  //         title: i18n.t('sidebar.creditDeviceAudit'),
  //         icon: 'app'
  //       }
  //     }
  //   ]
  // },

  {
    path: '/userInfo',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'details',
        name: 'UserInfo',
        component: _import('userInfo/Layout'),
        meta: { title: i18n.t('sidebar.UserInfo'), icon: 'userInfo' },
        children: [
          {
            path: 'details',
            name: 'UserInfoDetails',
            component: _import('userInfo/index'),
            meta: {
              active: '/userInfo/details',
              title: i18n.t('sidebar.BaseInfo')
            },
            hidden: true
          },
          {
            path: 'setPwd',
            name: 'UserInfoSetPwd',
            component: _import('userInfo/setPwd/index'),
            meta: {
              active: '/userInfo/details',
              title: i18n.t('sidebar.SetPwd')
            },
            hidden: true
          },
          {
            path: 'setPhone',
            name: 'UserInfoSetPhone',
            component: _import('userInfo/setPhone/index'),
            meta: {
              active: '/userInfo/details',
              title: i18n.t('sidebar.SetPhone')
            },
            hidden: true
          }
          // {
          //   path: 'setEmail',
          //   name: 'UserInfoSetEmail',
          //   component: _import('userInfo/setEmail/index'),
          //   hidden: true
          // }
        ]
      }
    ],
    hidden: true
  },

  // {
  //   path: '/reportExport',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       component: _import('reportExport/index'),
  //       name: 'ReportExport',
  //       meta: { title: i18n.t('sidebar.ReportExport'), icon: 'report' }
  //     }
  //   ]
  // },
  {
    path: '/carCode',
    component: Layout,
    children: [
      {
        path: '',
        component: _import('carCode/index'),
        name: 'CarCode',
        meta: { title: i18n.t('carCode.CarCode'), icon: 'report' }
      }
    ]
  },
  {
    path: '/datasync',
    component: Layout,
    children: [{
      path: '',
      component: _import('datasync/index'),
      name: 'datasync',
      meta: {
        title: i18n.t('datasync.sync'),
        icon: 'log'
      }
    }]
  },
  // {
  //   path: '/jobMng',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       redirect: 'list',
  //       name: 'JobMng',
  //       component: _import('common/Layout'),
  //       meta: { title: i18n.t('sidebar.PostMng'), icon: 'job' },
  //       children: [
  //         {
  //           path: 'list',
  //           name: 'JobMngList',
  //           component: _import('jobMng/index'),
  //           meta: {
  //             active: '/jobMng/list',
  //             title: i18n.t('sidebar.PostList'),
  //             icon: 'job'
  //           },
  //           hidden: true
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   path: '/staffMng',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       redirect: 'list',
  //       name: 'StaffMng',
  //       component: _import('common/Layout'),
  //       meta: { title: i18n.t('sidebar.StaffMng'), icon: 'staff' },
  //       children: [
  //         {
  //           path: 'list',
  //           name: 'StaffMngList',
  //           component: _import('staffMng/index'),
  //           meta: {
  //             active: '/staffMng/list',
  //             title: i18n.t('sidebar.StaffMng'),
  //             icon: 'staff'
  //           },
  //           hidden: true
  //         }
  //       ]
  //     }
  //   ]
  // }
  // { path: '*', redirect: '/404', hidden: true }
]
export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  base: window.__POWERED_BY_QIANKUN__ ? BASE_URL : '/'
})



// WEBPACK FOOTER //
// ./src/router/index.js